import React from "react";
import imgCN from './imgs/rled6-cn.jpg';
import imgCN2 from "./imgs/18-光固化机（蓝）旧版.jpg"
import img1en from "./imgs/1en.jpg";
import img2en from "./imgs/2en.jpg";
import img3en from "./imgs/3en.jpg";
import img4en from "./imgs/4en.jpg";
import img5en from "./imgs/5en.jpg";
import img6en from "./imgs/6en.jpg";
import img7en from "./imgs/7en.jpg";
import img8en from "./imgs/8en.jpg";
import img9en from "./imgs/18-RLED 6.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";

export function RLED6() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={imgCN2}/>
                    <img className="product-img" src={imgCN}/>
                </>
                : <>
                    <img className="product-img" src={img9en}/>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                    <img className="product-img" src={img4en}/>
                    <img className="product-img" src={img5en}/>
                    <img className="product-img" src={img6en}/>
                    <img className="product-img" src={img7en}/>
                    <img className="product-img" src={img8en}/>
                </>
            }
        </>
    )
}
